module.exports = __webpack_public_path__ + "img/Drehleiter_mit_Korb.e10f73fa.svg";